var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.model)?_c('div',{staticClass:"model"},[_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.$t('messenger.threed_model'))+" ")]),_c('img',{attrs:{"src":_vm.model.modifications[0].url_icon}}),_c('div',{staticClass:"model-name"},[_vm._v(" "+_vm._s(_vm.model.name)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }